export default __webpack_public_path__ + "static/media/press-02.1b211bf6.jpg";